<template>
  <div class=" section_sectionWrapper">
    <div class="module-copyright">
      <div class="copyright-cont">
        <div class="pr">
          <div class="b-cnt">
            <a href="https://privacy.ujoygames.jp/" target="_blank" id="privacypolicy" class="privacypolicy"></a>
            <a href="https://ashechoes.jp/faq/index.html" target="_blank" id="faq" class="faq"></a>
            <a href="https://commerce.ujoygames.jp/" target="_blank" id="commerce" class="commerce"></a>
            <a href="https://useragreement.ujoygames.jp/" target="_blank" id="useragreement" class="useragreement"></a>
            <a href="https://settlement.ujoygames.jp/" target="_blank" id="settlement" class="settlement"></a>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'app',


  data() {
    return {

    }
  },
  methods: {
    handleIcon(item) {
      alert(item)
    }
  },
  watch: {


  }
}
</script>
<style lang="scss" scoped>
.module-copyright {
  position: relative;
  height: 100%;
  width: 100%;
  // width: 1920px;
  // height: 1080px;

  .copyright-cont {
    width: 1179px;
    height: 717px;
    background-image: url("../../assets/img/copyright.png");
    background-size: 100% 100%;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 50%;


    .pr {
      width: 727px;
      height: 49px;
      background-image: url("../../assets/img/pr.png");
      background-size: 100% 100%;
      position: absolute;
      bottom: 102px;
      left: 50%;
      transform: translate(-50%, 0);

      .b-cnt {
        position: relative;
        width: 100%;
        height: 100%;

        .privacypolicy {
          width:165px;
          height: 28px;
          position: absolute;
          top: 0;
          left: 0;

        }

        .faq {
          width:108px;
          height: 28px;
          position: absolute;
          top: 0;
          left: 170px;

        }

        .commerce {
          width:110px;
          height: 28px;
          position: absolute;
          top: 0;
          left: 282px;

        }

        .useragreement {
          width:145px;
          height: 28px;
          position: absolute;
          top: 0;
          right: 185px;

        }

        .settlement {
          width: 180px;
          height: 28px;
          position: absolute;
          top: 0;
          right: 0;
        }



      }

    }
  }
}

@media screen and (min-width: 2560px) and (max-width: 3440px) {
  .module-copyright {

    .copyright-cont {
      width: 943px !important;
      height: 574px !important;

      .pr {
        width: 654px !important;
        height: 45px !important;
        bottom: 80px !important;
        .privacypolicy{
          width: 150px !important;
        }
        .faq{
          width: 98px !important;
          left: 156px !important;

        }
        .commerce{
          width: 98px !important;
          left: 256px !important;

        }
        .useragreement{
          width: 130px !important;
          right: 165px !important;

        }
        .settlement{
          width:166px !important;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/copyright.vue